<script>
import { isArray, isNil, isNumber, isNull, isString, toNumber } from 'lodash/fp'

import FormFieldAutocomplete from './FormFieldAutocomplete'
import FormFieldTextInput from './FormFieldTextInput'
import FormFieldSwitch from './FormFieldSwitch'
import FormFieldRadio from './FormFieldRadio'
import FormFieldCombobox from './FormFieldCombobox'
import FormFieldSelect from './FormFieldSelect'
import FormFieldCheckbox from './FormFieldCheckbox'

export default {
  name: 'FormField',
  props: {
    field: {
      type: Object,
      required: true
    },
    fieldKey: {
      type: String,
      required: true
    },
    errorMessages: {
      type: Array,
      required: false
    },
    value: {}
  },
  computed: {
    classes () {
      return this.field.classes && this.field.classes.length
        ? isString(this.field.classes)
          ? this.field.classes
          : isArray(this.field.classes)
            ? this.field.classes
            : 'xs12'
        : 'xs12'
    }
  },
  methods: {
    emitValue (value) {
      let emitValue = value
      if (this.field.type === 'float') {
        console.log('isNil(value): ', isNil(value))
        console.log('isNull(value)', isNull(value))
        console.log('isNumber(toNumber(value))', isNumber(toNumber(value)))
        const numValue = toNumber(value)
        emitValue = value && !isNil(value) && !isNull(value) && isNumber(numValue) && !isNaN(numValue)
          ? numValue
          : value
      }
      return emitValue
    },
    onInput (value) {
      console.log('onInput', value)
      this.$emit('customInput', this.emitValue(value))
    },
    onBlur (event) {
      console.log('onBlur: ', event)
      const value = event.target.value
      console.log('value: ', value)
      this.$emit('customBlur', this.emitValue(value))
    },
    onFocus (event) {
      console.log('onFocus: ', event)
      const field = this.$refs.field
      console.log('field', field)
      if (field._name === '<VSelect>' && !field.isMenuActive) field.isMenuActive = true
    }
  },
  render (h) {
    /*
    console.log('Rendering FormField')
    console.group('Props: ')
    console.log('field', this.field)
    console.log('fieldKey', this.fieldKey)
    console.log('errorMessages', this.errorMessages)
    console.log('value', this.value)
    console.groupEnd()
    */

    const fieldRenderStrategies = {
      string: FormFieldTextInput,
      float: FormFieldTextInput,
      switch: FormFieldSwitch,
      radio: FormFieldRadio,
      combobox: FormFieldCombobox,
      select: FormFieldSelect,
      checkbox: FormFieldCheckbox,
      autocomplete: FormFieldAutocomplete
    }

    /* Create Field
    console.log('field: ', this.field)
    console.log('this.field.attributes', this.field.attributes)
    console.log('field type', this.field.type)
    console.log('fieldRenderStrategies: ', fieldRenderStrategies)
    */
    const self = this
    const fieldRender = fieldRenderStrategies[this.field.type]
      ? fieldRenderStrategies[this.field.type](h, self.field, self.errorMessages, self.value, self.onInput, self.onBlur, self.onFocus, self)
      : null

    return (<v-flex class={this.classes}>{ fieldRender }</v-flex>)
  }
}
</script>

<style lang="stylus">
@import '~vuetify/src/stylus/settings/_variables.styl'

.input__wrapper
  &&--centered
    display: flex
    justify-content: center
    flex-direction: column
    align-items: center

    @media $display-breakpoints.xs-only
      align-items: flex-start

.input--radio--row__wrapper
  display: flex
  justify-content: center
  align-items: baseline
  flex-direction: column
  margin-top: 0

  .input--radio__label
    transform: translateX(-8px) scale(0.75)

  .v-input
    margin-top: 0
    padding-top: 0

.v-input--radio-group__input
  width: auto

</style>
